import { FC } from 'react';

import { noMark } from 'images';
import Advert from 'portfolio3/components/common/Advert';
import { emitYMEvent } from 'portfolio3/features/yandexMetrika';
import { SxStyles } from 'types';

const DiagnosticsResultBanner: FC = () => {
  const contentSx: SxStyles = {
    backgroundImage: `url(${noMark})`,
    backgroundPosition: 'right 0 top 11px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '201px 180px',
  };

  const handleClick = () => {
    emitYMEvent({ type: 'diagnosticResultsBanner' });
  };

  return (
    <Advert
      title="Результаты диагностик"
      prompt="На сайте можно посмотреть подробную информацию о всех пройденных диагностиках и скачать результаты"
      linkText="Перейти на сайт МЦКО"
      href="https://okmcko.mos.ru/"
      contentSx={contentSx}
      onLinkClick={handleClick}
    />
  );
};

export default DiagnosticsResultBanner;
